import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Spacer from "./Spacer"
import Button from "./Button"
import Teaser from "./Teaser"
import Link from "./Link"

import { mixins, media } from "../styles"

const Grid = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-flow: column nowrap;
  gap: 30px;
  list-style: none;
  margin: 0;
  padding: 0;

  @media ${media.md} {
    flex-flow: row wrap;
    justify-content: center;
    gap: 50px;
    padding: 0 35px;
  }

  @media ${media.lg} {
    gap: 30px;
    padding: 0 35px;
  }

  @media ${media.xl} {
    padding: 0 17%;
  }
`

const GridItem = styled.li`
  flex: 0 0 calc(50% - 25px);
  margin: 0;
  padding: 0;

  @media ${media.lg} {
    flex: 0 0 calc(33.333333333% - 20px);
  }
`

const Header = styled.div`
  text-align: center;

  h2 {
    ${mixins.title4}
  }
`

const ButtonRow = styled.div`
  padding: 15px 0;
  text-align: center;
`

const TeaserCollection = ({ buttonLink, buttonText, header, items }) => {
  return (
    <>
      <Header>
        <h2>{header}</h2>
      </Header>
      <Spacer height={20} lg={30} xl={40} />
      <Grid aria-label={header}>
        {items.map((item) => (
          <GridItem key={item.id}>
            <Teaser
              compact
              to={item.link}
              localImage={
                item.image.childImageSharp?.gatsbyImageData ||
                item.image.gatsbyImageData
              }
              header={item.title}
              headerLevel={3}
            />
          </GridItem>
        ))}
      </Grid>
      {buttonLink && buttonText && (
        <ButtonRow>
          <Button arrow outline as={Link} to={buttonLink}>
            {buttonText}
          </Button>
        </ButtonRow>
      )}
    </>
  )
}

TeaserCollection.propTypes = {
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  header: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      image: PropTypes.object.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default TeaserCollection
